module.exports = __webpack_public_path__ + "static/media/inactive-currency.998a16fc.svg";